<template>
    <div>
        <div class="col-12">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>SKU:</strong>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        {{ sku }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Componente de Origen:</strong>
                    </div>
                </div>
            </div>
            <div v-if="originComponent" class="row">
                <div class="col">
                    <div class="form-group">
                        {{ originComponent.name }}
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col">
                    <div class="form-group">
                        <strong>Año Cosecha</strong>
                        <v-select :options="saleZoneYears" v-model="year" @input="changeHarvestToSaleZone()">
                            <span slot="no-options">No se encontraron Año Cosecha</span>
                        </v-select>                            
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Zona de Venta</strong>
                        <v-select :options="salesZone" v-model="saleZone" @input="changeSaleZone(saleZone)">
                            <span slot="no-options">No se encontraron Zonas de Venta</span>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" v-if="ListComponentSaleZone.length > 0">
            <table class="table table-sm">
                <tr>
                    <th>Componentes Asociados <span class="ml-4 text-light"><i>(Seleccionar Componentes)</i></span>
                    </th>
                </tr>
                <tr>
                    <td>
                        <div class="form-group">
                            <div class="form-check" v-for="lc in ListComponentSaleZone" :key="lc.id">
                                <input :value="lc.c_component" v-model="newComponentSelected" class="form-check-input" type="radio" name="newComponent" :id="'list-component-' + lc.c_component"
                                />
                                <label class="ml-4"
                                    :for="'list-component-' + lc.c_component">{{ lc.d_component }}</label>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <button v-if="Object.keys(newComponentSelected).length > 0" type="button" @click="addComponentToRevision" class="btn btn-block btn-success">
                        <i class="fa fa-send"></i>
                        Seleccionar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//import $ from "jquery";
import { Get } from "../../../helper/axios.js";
export default {
    props: ["sku", "originComponent"],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            newComponentSelected: null,
            componentFormula: [],
            ListComponentSaleZone: [],
            salesZone: [],
            saleZoneYears: [],
            year: "",
            saleZone: "",
            Get
        };
    },
    computed:  {
        btnDisabled() {
            return true
        }
    },
    created(){
        this.index();
    },
    watch:{
        originComponent:function(){
            this.index()
        }
    },
    methods: {
        index(){
            this.clearAll();
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/formulas/getHarvestFormulas/"+this.sku, (res) => {
                this.saleZoneYears = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        changeHarvestToSaleZone(){
            this.clearFromChangeSaleZoneOrHarvest();
            this.salesZone = [];
            this.saleZone = null;
            if (this.year)
            {
                this.salesZone = [];
                this.Get(this.apiUrl + `v1/formulas/getSaleZones?sku=${this.sku}&harvest=${this.year}`, (res) => {
                    res.data.forEach((element) => {
                        this.salesZone.push({
                            code: element.code,
                            label: element.saleZone
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }
        },
        clearFromChangeSaleZoneOrHarvest(){
            this.ListComponentSaleZone = [];
        },
        clearAll(){
            this.salesZone = [];
            this.saleZone = null;
            this.clearFromChangeSaleZoneOrHarvest()
            this.saleZoneYears = [];
            this.year = "";
            this.newComponentSelected = {}
        },
        changeSaleZone() {
            this.$store.commit("setLoading", true);
            this.clearFromChangeSaleZoneOrHarvest();
            let saleZoneAtr =  '';
            if (this.saleZone.code)
                saleZoneAtr = `&saleZone=${this.saleZone.code}`

            if (this.saleZone && this.year) {
                this.Get(this.apiUrl + `v1/formulas/getFormulasBySkuAndHarvest?sku=${this.sku}&harvest=${this.year}${saleZoneAtr}`, (res) => {
                    this.componentFormula = res.data.formulas;
                    this.componentFormula.forEach((element) => {
                        this.ListComponentSaleZone.push(element);
                    });
                    this.$store.commit("setLoading", false);
                });
            }
            this.$store.commit("setLoading", false);
        },
        SelectNewComponent(){
            
        },
        addComponentToRevision(){
            let component = this.ListComponentSaleZone.filter(x => x.c_component == this.newComponentSelected);
            let name = '';
            if (component != null)
            {
                if (component.length > 0)
                {
                    name = component[0].name
                }
            }
            this.$emit('addComponentToRevision', this.newComponentSelected, name, this.year, this.saleZone.label);
            this.salesZone = [];
            this.saleZone = null;
            this.saleZoneYears = [];
            this.year = "";

        }
    },
};
</script>
  